import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Database20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4 7.5C4.55228 7.5 5 7.05228 5 6.5C5 5.94772 4.55228 5.5 4 5.5C3.44772 5.5 3 5.94772 3 6.5C3 7.05228 3.44772 7.5 4 7.5Z'
      fill='currentColor'
    />
    <path d='M8 5.75H16V7.25H8V5.75Z' fill='currentColor' />
    <path
      d='M5 13.5C5 14.0523 4.55228 14.5 4 14.5C3.44772 14.5 3 14.0523 3 13.5C3 12.9477 3.44772 12.5 4 12.5C4.55228 12.5 5 12.9477 5 13.5Z'
      fill='currentColor'
    />
    <path d='M16 12.75H8V14.25H16V12.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.637259 10C0.38585 9.66502 0.25 9.25459 0.25 8.83333V3.58333C0.25 2.866 0.838694 2.25 1.5625 2.25H18.4375C19.1613 2.25 19.75 2.866 19.75 3.58333V8.83333C19.75 9.25459 19.6142 9.66502 19.3627 10C19.6142 10.335 19.75 10.7454 19.75 11.1667V16.4167C19.75 17.134 19.1613 17.75 18.4375 17.75H1.5625C0.838693 17.75 0.25 17.134 0.25 16.4167V11.1667C0.25 10.7454 0.38585 10.335 0.637259 10ZM1.75 8.83333V3.75H18.25V8.83333C18.25 9.07015 18.0571 9.25 17.875 9.25H2.125C1.94294 9.25 1.75 9.07014 1.75 8.83333ZM2.125 10.75C1.94294 10.75 1.75 10.9299 1.75 11.1667V16.25H18.25V11.1667C18.25 10.9299 18.0571 10.75 17.875 10.75H2.125Z'
      fill='currentColor'
    />
  </Svg>
);

Database20.displayName = 'Database20';
export default Database20;
